(function (Drupal, once) {
  Drupal.behaviors.fixWebformCheckboxErrors = {
    attach(context: HTMLElement) {

      once('fix-webform-checkbox-errors', '.js-webform-checkboxes', context)
        .forEach((container) => {

          const checkboxContainer = container as HTMLElement;

          const observer = new MutationObserver(() => {

            const errors: HTMLElement[] = [];
            let sibling = checkboxContainer.nextElementSibling as HTMLElement | null;

            while (
              sibling &&
              sibling.matches('strong.error.form-item--error-message')
              ) {
              errors.push(sibling);
              sibling = sibling.nextElementSibling as HTMLElement | null;
            }

            if (errors.length > 1) {
              errors.slice(1).forEach(e => e.remove());
            }
          });

          observer.observe(checkboxContainer.parentNode as Node, {
            childList: true
          });
        });
    }
  };
})(Drupal, once);
